import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import "./plugins/vuetify-money.js";
import axios from 'axios'
import '@mdi/font/css/materialdesignicons.css'

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

// Alertas 
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

// Galeria 
import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin)

// Iconos

import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Vuetify from 'vuetify/lib'
Vue.use(Vuetify)


import VueQrcodeReader from 'vue-qrcode-reader'
Vue.use(VueQrcodeReader)

import { StreamBarcodeReader } from 'vue-barcode-reader'; 
Vue.component('StreamBarcodeReader', StreamBarcodeReader);


// iconos boostrap
import BootstrapVueIcons  from 'bootstrap-vue';
import './registerServiceWorker'

// Excel
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter)


import VueQuagga from 'vue-quaggajs';
Vue.use(VueQuagga);




// Guarda la direccion princial de la web
//axios.defaults.baseURL='https://192.168.101.4:8080/'
//axios.defaults.baseURL='http://192.168.1.67:8080/'
//axios.defaults.baseURL='http://www.core.core.com/'
//axios.defaults.baseURL='http://localhost:50862/'   
//axios.defaults.baseURL='https://www.paezcomputacion.com/'  
//axios.defaults.baseURL='http://192.168.1.155:8080'  
axios.defaults.baseURL=process.env.VUE_APP_CLOUDINARY_URL_MAIN   
//axios.defaults.baseURL='http://192.168.1.108:8090/sblaravel/public/' 
//axios.defaults.baseURL='https://www.paezcomputacion.com/gasbenito/public/'           
new Vue({
  router,
  store,
  vuetify,
  icons: {
    iconfont: 'mdi', // ¡Esta línea es la que le dice a Vuetify que use MDI!
  },
  render: h => h(App)
}).$mount('#app')   
   